import React from 'react'
import { Box, Heading } from 'grommet'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Input from './input'
import { setChoices } from '../../redux/rdg/actions'
import { device } from '../../theme/device'
import { useHideInput } from '../../contextHook/hideInput'
import HideShuffleTitleButton from '../Button/HideShuffleTitleButton'
import InputLength from '../Common/InputLength'

const Container = styled(Box)`
  border-radius: 2rem;
  box-shadow: 0px 0px 2px 1px ${props => props.theme.global.colors.border};
  min-height: 0px;
  padding: 1.3rem 2rem 2rem;
  width: 50rem;
  background-color: ${props => props.theme.global.colors.baseBackground};
  @media ${device.medium} {
    /* border-radius: 1.5rem; */
    padding: 1.3rem 0.8rem 2rem;
    /* height: 32rem; */
  }
  /* width: 50rem;
  padding: 1rem 0;
  @media ${device.medium} {
    height: ${props => props.containerHeight};
  } */
`

const ReactRDG = ({ inputOptions }) => {
  const choices = useSelector(state => state.rdg.choices)
  const { setHiding } = useHideInput()
  const dispatch = useDispatch()

  const shuffle = () => {
    let arra1 = choices.slice(0)
    let ctr = arra1.length
    let temp
    let index

    // While there are elements in the array
    while (ctr > 0) {
      // Pick a random index
      index = Math.floor(Math.random() * ctr)
      // Decrease ctr by 1
      ctr--
      // And swap the last element with it
      temp = arra1[ctr]
      arra1[ctr] = arra1[index]
      arra1[index] = temp
    }
    dispatch(setChoices(arra1.slice(0)))
  }

  return (
    <Container justify="start">
      <Box align="center" gap=".7rem" direction="row" justify="between">
        <Box direction="row" align="center" gap=".6rem">
          <Heading level={3} alignSelf="center" margin={{ vertical: '0px' }}>
            INPUTS
          </Heading>
          {choices.length > 0 && <InputLength length={choices.length} />}
        </Box>
        <HideShuffleTitleButton setHiding={setHiding} shuffle={shuffle} />
      </Box>
      {/* <Text margin={{ bottom: '3rem' }}>
        <Text size="2rem">History: </Text>
        {olderHistory.length > 0 && (
          <Text size="2.2rem">{olderHistory.join(', ')}, </Text>
        )}
        <Text weight="bold" size="2.2rem">
          {popped}
        </Text>
      </Text> */}

      <Input inputOptions={inputOptions} />
    </Container>
  )
}

export default ReactRDG
